import { render } from "./load-document.vue?vue&type=template&id=046d5a99"
import script from "./load-document.vue?vue&type=script&lang=js"
export * from "./load-document.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__